/**
 * Story 10.7 — view-model PURO do "Menu do Trader" (CAP-14).
 *
 * FONTE ÚNICA dos cinco destinos. Vive aqui (e não no JSX da nav/side-menu/footer) para ser
 * testável sob o `environment: "node"` do vitest: devolve DADOS, nunca elementos React. Nav
 * desktop, menu mobile, rodapé, sitemap e robots consomem-no — não redeclaram a lista à mão
 * (padrão de `footer-view-model.ts`).
 *
 * Ordem, rótulos e slugs vêm da produção viva (virtualeurope.net, verificado em 2026-07-22);
 * zero fabricação. Todos os `href` são rotas INTERNAS (`LocalizedClientLink`), nunca `"#"`/`""`
 * nem `target="_blank"`. O rótulo do menu ("Cotações Criptos") é o da produção e difere de
 * propósito do `<h1>` da própria página ("Cotações Cripto").
 */

export type TraderMenuLinkKey =
  | "calendario"
  | "visao-geral-do-mercado"
  | "cotacao-cripto"
  | "graficos"
  | "suporte"

export interface TraderMenuLink {
  key: TraderMenuLinkKey
  /** Rótulo visível do link, exatamente como a produção o nomeia. */
  label: string
  /** Rota interna exata (começa por `/`, sem barra final, sem `target="_blank"`). */
  href: string
}

/**
 * Os cinco destinos do Menu do Trader, em ordem de renderização da produção
 * (calendário → visão geral → cripto → gráficos → suporte). Array fresco por chamada
 * (idioma do `footer-view-model`), para nenhum consumidor mutar a fonte.
 */
export function getTraderMenuLinks(): TraderMenuLink[] {
  return [
    { key: "calendario", label: "Calendário Econômico", href: "/calendario" },
    {
      key: "visao-geral-do-mercado",
      label: "Visão Geral do Mercado",
      href: "/visao-geral-do-mercado",
    },
    { key: "cotacao-cripto", label: "Cotações Criptos", href: "/cotacao-cripto" },
    { key: "graficos", label: "Gráficos", href: "/graficos" },
    { key: "suporte", label: "Suporte", href: "/suporte" },
  ]
}
